// extracted by mini-css-extract-plugin
export var emptyView = "search-result-list-module--emptyView--3RyPt";
export var emptyText = "search-result-list-module--emptyText--3l_q5";
export var list = "search-result-list-module--list--3uwsP";
export var listItem = "search-result-list-module--listItem--1Dvj6";